/** Strona główna: zakładki oferty oraz powrót na górę. Menu ma osobną implementację. */
document.addEventListener('DOMContentLoaded', () => {
    const page = document.querySelector('.homepage');
    if (!page) return;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const offer = page.querySelector('#oferta');
    if (offer) {
        const buttons = [...offer.querySelectorAll('[data-kpg-tab]')];
        const panels = [...offer.querySelectorAll('[role="tabpanel"]')];
        const show = (id, scroll = false, focus = false) => {
            const active = panels.find(panel => panel.id === id);
            if (!active) return false;
            offer.classList.add('is-js');
            panels.forEach(panel => {
                panel.classList.toggle('is-on', panel === active);
                panel.hidden = panel !== active;
            });
            buttons.forEach(button => {
                const selected = button.dataset.kpgTab === id;
                button.setAttribute('aria-selected', String(selected));
                button.tabIndex = selected ? 0 : -1;
                if (selected && focus) button.focus();
            });
            if (scroll) offer.scrollIntoView({ behavior: reduceMotion.matches ? 'auto' : 'smooth', block: 'start' });
            return true;
        };
        const hashId = () => {
            try { return decodeURIComponent(window.location.hash.slice(1)); }
            catch { return ''; }
        };
        if (buttons.length && !show(hashId(), Boolean(hashId()))) show(buttons[0].dataset.kpgTab);
        offer.addEventListener('click', event => {
            const button = event.target.closest('[data-kpg-tab]');
            if (button) show(button.dataset.kpgTab);
        });
        offer.querySelector('[role="tablist"]').addEventListener('keydown', event => {
            const index = buttons.indexOf(event.target.closest('[role="tab"]'));
            if (index < 0) return;
            let next;
            if (event.key === 'ArrowRight') next = (index + 1) % buttons.length;
            if (event.key === 'ArrowLeft') next = (index - 1 + buttons.length) % buttons.length;
            if (event.key === 'Home') next = 0;
            if (event.key === 'End') next = buttons.length - 1;
            if (next !== undefined) {
                event.preventDefault();
                show(buttons[next].dataset.kpgTab, false, true);
            }
        });
        page.addEventListener('click', event => {
            const link = event.target.closest('a[href]');
            if (!link) return;
            const url = new URL(link.href, window.location.href);
            if (url.origin !== window.location.origin || url.pathname !== window.location.pathname || url.search !== window.location.search) return;
            let id;
            try { id = decodeURIComponent(url.hash.slice(1)); } catch { return; }
            if (id && show(id, true)) {
                event.preventDefault();
                window.history.pushState(null, '', url.hash);
            }
        });
        window.addEventListener('hashchange', () => show(hashId(), true));
        window.addEventListener('popstate', () => show(hashId() || buttons[0]?.dataset.kpgTab, true));
    }

    const top = document.createElement('button');
    top.type = 'button';
    top.className = 'kpg-top';
    top.setAttribute('aria-label', 'Przewiń do góry strony');
    top.innerHTML = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 19V5M5 12l7-7 7 7"/></svg>';
    top.addEventListener('click', () => {
        window.scrollTo({ top: 0, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
        const target = page.querySelector('h1');
        if (target) { target.setAttribute('tabindex', '-1'); target.focus({ preventScroll: true }); }
    });
    page.appendChild(top);
    let pending = false;
    const update = () => {
        top.classList.toggle('is-on', window.scrollY > 600);
        pending = false;
    };
    window.addEventListener('scroll', () => {
        if (!pending) { pending = true; window.requestAnimationFrame(update); }
    }, { passive: true });
    update();
});
